var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.646.646a.5.5 0 0 1 .708 0L4 3.293 6.646.646a.5.5 0 1 1 .708.708L4.707 4l2.647 2.646a.5.5 0 1 1-.708.708L4 4.707 1.354 7.354a.5.5 0 1 1-.708-.708L3.293 4 .646 1.354a.5.5 0 0 1 0-.708Z"
  })));
};

export default SvgX;